// extracted by mini-css-extract-plugin
var _1 = "StageComponentStyles-module__label___jRSO3";
var _2 = "StageComponentStyles-module__select___VRFW4";
var _3 = "StageComponentStyles-module__stage__add--stage___Oapjr";
var _4 = "StageComponentStyles-module__stage__list___P0SSn";
var _5 = "StageComponentStyles-module__stage__list--element___CQpI1";
var _6 = "StageComponentStyles-module__stage__add--stage___Oapjr";
var _7 = "StageComponentStyles-module__stage__list___P0SSn";
var _8 = "StageComponentStyles-module__stage__list--element___CQpI1";
var _9 = "StageComponentStyles-module__wrapper___GTEQR";
export { _1 as "label", _2 as "select", _3 as "stageAddStage", _4 as "stageList", _5 as "stageListElement", _6 as "stage__add--stage", _7 as "stage__list", _8 as "stage__list--element", _9 as "wrapper" }
